'use strict';

(() => {
    const menuDrawerContainer = document.querySelector('.menu-drawer-container');
    const mobileNavOpen = document.querySelector('#open-mobile-nav');
    const headerSection = document.querySelector('.section-custom-header:has(.header-custom)');
    const closeDrawer = document.querySelector('.header-custom .close-drawer');

    if (!menuDrawerContainer || !mobileNavOpen || !headerSection) return;

    const setDrawerOpenState = (isOpen) => {
        mobileNavOpen.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
            menuDrawerContainer.classList.add('menu-opening');
            headerSection.classList.add('menu-open');
            document.documentElement.classList.add('overflow-hidden-tablet');
            document.body.classList.add('overflow-hidden-tablet');
            return;
        }

        menuDrawerContainer.classList.remove('menu-opening');
        headerSection.classList.remove('menu-open');
        document.documentElement.classList.remove('overflow-hidden-tablet');
        document.body.classList.remove('overflow-hidden-tablet');
    };

    menuDrawerContainer.addEventListener('toggle', () => {
        setDrawerOpenState(menuDrawerContainer.open);
    });

    if (closeDrawer) {
        closeDrawer.addEventListener('click', () => {
            setDrawerOpenState(false);

            setTimeout(() => {
                menuDrawerContainer.removeAttribute('open');
            }, 400);
        });
    }
})();
